import faceLogin from './facebook'
export const FacebookLogin = faceLogin